module.exports = "<div class=\"popup__block\">\n  <div class=\"bgblock\"></div>\n  <div class=\"popupcontainer\" [ngClass]=\"customclass\">\n    <div class=\"closediv\"><h1 class=\"closeicon popup icon ion-android-close\" (click)=\"close_popup()\"></h1></div>\n    <div class=\"productcontainer w-clearfix\">\n        <ng-content></ng-content>\n    </div>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /Users/matthijs/projects/PHILIPS/philips-dental-pro/shop/src/app/components/popup/popup.component.html
// module id = ../../../../../src/app/components/popup/popup.component.html
// module chunks = main